import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress
} from '@mui/material';
import api from '../../services/api';

const PlayerCoachConfirmation = ({ 
    open, 
    onClose, 
    onSuccess,
    loading = false 
}) => {
    const handleConfirm = async () => {
        try {
            // Update coaching status in our database
            const response = await api.put('/users/client/status', {
                isCoachingOrPlaying: true
            });

            // Call the success callback with the response
            if (onSuccess) {
                onSuccess(response.data);
            }
        } catch (error) {
            // Let the parent component handle the error
            if (onClose) {
                onClose(error);
            }
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="coaching-dialog-title"
        >
            <DialogTitle id="coaching-dialog-title">
                Confirm Coaching/Playing Status
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    By confirming that you coach or play at Total Turf Experience, you will be required to pay administrative fees in addition to your children. Do not select this option if you will not be participating with your children. Do you want to proceed?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleConfirm} 
                    color="primary" 
                    variant="contained"
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PlayerCoachConfirmation; 